import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Grid, Dimmer, Loader} from 'semantic-ui-react';
import {Actions} from '../../common/actions';

class GeneralData extends Component {
  renderLoader() {
    const {loading} = this.props;
    if (loading) {
      return (
        <Dimmer active inverted>
          <Loader inverted content={'Consultando...'} />
        </Dimmer>
      );
    }
  }

  renderColumn(width, type, text = '') {
    if (type === 'label' && !text) {
      return;
    }
    return (
      <Grid.Column width={width}>
        {type === 'label' ? <h4>{text}:</h4> : `${text}`}
      </Grid.Column>
    );
  }

  render() {
    const {generalData} = this.props;
    const model =
      generalData.suffix && generalData.katashiki ?
        `${generalData.suffix}/${generalData.katashiki}` :
        '';

    return (
      <Card raised fluid>
        {this.renderLoader()}
        <div className='title-bar'>
          <div className='title'>
            <h2>Datos Generales</h2>
          </div>
          <div className='filters-section'>
            <Grid textAlign='left'>
              <Grid.Row>
                {this.renderColumn(1, 'label', 'Modelo')}
                {this.renderColumn(4, 'value', model)}
                {this.renderColumn(2, 'label', 'Vehículo')}
                {this.renderColumn(3, 'value', generalData.description)}
                {this.renderColumn(2, 'label', 'Color Externo')}
                {this.renderColumn(3, 'value', generalData.externalColor)}
              </Grid.Row>
              <Grid.Row>
                {this.renderColumn(1, 'label', 'Motor')}
                {this.renderColumn(4, 'value', generalData.motor)}
                {this.renderColumn(2, 'label', 'Año Producción')}
                {this.renderColumn(3, 'value', generalData.productionYear)}
                {this.renderColumn(2, 'label', 'Color Interno')}
                {this.renderColumn(3, 'value', generalData.internalColor)}
              </Grid.Row>
              <Grid.Row>
                {this.renderColumn(1, 'label', 'Ubicación')}
                {this.renderColumn(4, 'value', generalData.location)}
              </Grid.Row>
            </Grid>
          </div>
        </div>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.vehicleHistory.loadingGeneralData,
    'generalData': state.vehicleHistory.generalData,
  };
};
  
const {
  fetchTasksByOrder,
} = Actions;

export default connect(mapStateToProps, {
  fetchTasksByOrder,
})(GeneralData);
